import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full mb-2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "mx-4 pt-6 pb-4 bg-white border-t text-left"
}

import {
  watch,
} from "vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import lockedIcon from "@/assets/icons/locked.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionComponent',
  props: /*@__PURE__*/_mergeModels({
    type: { default: "transparent" },
    isBlocked: { type: Boolean, default: false }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["opened"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {



const emits = __emit;
const isOpen = _useModel<boolean>(__props, "modelValue");

watch(isOpen, (newValue) => {
  if (newValue) {
    emits("opened");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["border rounded-2xl border-ternary group", { 'bg-white': isOpen.value || __props.type === 'white' }])
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["w-full text-left pl-4 pr-2 py-3 transition flex items-center h-16", __props.isBlocked ? 'justify-start gap-4' : 'justify-between']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
      }, [
        (__props.isBlocked)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(lockedIcon),
              alt: "locked",
              class: "size-5"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass(["text-xl font-semibold leading-[28px]", isOpen.value ? 'text-active' : 'text-brown group-hover:text-active'])
        }, [
          _renderSlot(_ctx.$slots, "title")
        ], 2),
        (!__props.isBlocked)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["size-10 text-white rounded-lg flex items-center justify-center", 
            isOpen.value
              ? 'bg-active'
              : 'bg-brown-gradient group-hover:bg-orange-gradient'
          ])
            }, [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([
              'w-5 h-5 transform transition-transform',
              isOpen.value ? 'rotate-180' : 'rotate-0',
            ]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 9l-7 7-7-7"
                }, null, -1)
              ]))], 2))
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "faq-content"),
            _createElementVNode("button", {
              class: "flex justify-center items-center w-full h-[60px] mt-6 text-xl font-normal leading-100p text-brown border border-divider rounded-[100px] hover:bg-hover hover:border-active hover:text-active transition-all duration-300 ease-in-out",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false))
            }, [
              _renderSlot(_ctx.$slots, "collapse-text-btn"),
              _createVNode(ArrowIcon, { class: "ml-6" })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})